import { on } from '@ngrx/store';
import * as ProductsActions from '../actions/products.actions';
import { ProductsState, productSettingsAdapter } from './products.reducer';

export const productSettingsReducers = [
    on(ProductsActions.getProductsSettings, (state: ProductsState) => ({
        ...state,
        loading: true,
        error: null,
        success: false,
    })),

    on(ProductsActions.getProductsSettingsSuccess, (state: ProductsState, { productsSettings }) => {
        return {
            ...state,
            productsSettings: productSettingsAdapter.setAll(productsSettings, state.productsSettings),
            loading: false,
            error: null,
            success: true,
        };
    }),

    on(ProductsActions.getProductsSettingsFailure, (state: ProductsState, { error }) => ({
        ...state,
        loading: false,
        error,
    })),

    on(ProductsActions.updateProductSettings, (state: ProductsState) => ({
        ...state,
        loading: true,
        error: null,
        success: false,
    })),

    on(ProductsActions.updateProductSettingsSuccess, (state: ProductsState, { productsSettings }) => {
        return {
            ...state,
            productsSettings: productSettingsAdapter.upsertOne(productsSettings, state.productsSettings),
            loading: false,
            error: null,
            success: true,
        };
    }),

    on(ProductsActions.updateProductSettingsFailure, (state: ProductsState, { error }) => ({
        ...state,
        loading: false,
        error,
    })),
];
